import React from "react";
import { formatPackagePrice, getPackageDetails } from "../data/packages";
import { PRICE_DISCLOSURE } from "../data/bookingPolicies";
import PrivatePackageFacts from "./PrivatePackageFacts";
import BookNow from "../pages/BookNow";
import Icon from "./Icon";
import "../css/Packages.css";

export default function PrivatePackageCard({ pkg, context = "page" }) {
  const isHome = context === "home";
  const titleId = `${isHome ? "preview" : "party"}-${pkg.id}-title`;
  return (
    <article
      id={isHome ? undefined : `party-${pkg.id}`}
      aria-labelledby={titleId}
      className={`private-package-card package-tone-${pkg.id} ${isHome ? "private-package-box" : "private-party-card"}`}
    >
      <div className="package-card-heading">
        <span className="package-emblem">
          <Icon name="crown" />
        </span>
        <p className="eyebrow">PRIVATE BIRTHDAY PARTY</p>
      </div>
      <h3 id={titleId} className="package-title">
        {pkg.title}
      </h3>
      <p className="package-description">{pkg.description}</p>
      <div className="price-box">
        <p className="package-price">{formatPackagePrice(pkg.price)}</p>
        <p className="private-party-price-note">{PRICE_DISCLOSURE}</p>
      </div>
      <PrivatePackageFacts pkg={pkg} />
      <details className="package-inclusions">
        <summary>
          Everything included <span aria-hidden="true">+</span>
        </summary>
        <ul className="package-details">
          {getPackageDetails(pkg).map((detail) => (
            <li key={detail.label}>
              <span>{detail.label}</span>
              <strong>{detail.value}</strong>
            </li>
          ))}
        </ul>
        <ul className="additional-info">
          {pkg.additionalInfo.map((info) => (
            <li key={info}>
              <Icon name="check" />
              <span>{info}</span>
            </li>
          ))}
        </ul>
        <p className="private-party-benefits-note">
          Benefits listed “for all kids” or “for all guests” cover everyone
          attending in those groups, including additional guests.
        </p>
      </details>
      <div className="package-card-actions">
        <BookNow packageId={pkg.id} />
      </div>
    </article>
  );
}
